import { reactive } from 'vue'

export type ToastType = 'success' | 'error' | 'info' | 'warning'

export interface Toast {
  id: number
  message: string
  type: ToastType
}

let _id = 0
const toasts = reactive<Toast[]>([])

export function useToast () {
  function add (message: string, type: ToastType = 'success', duration = 3500) {
    const id = ++_id
    toasts.push({ id, message, type })
    setTimeout(() => remove(id), duration)
  }

  function remove (id: number) {
    const idx = toasts.findIndex(t => t.id === id)
    if (idx !== -1) toasts.splice(idx, 1)
  }

  return {
    toasts,
    success: (msg: string) => add(msg, 'success'),
    error: (msg: string) => add(msg, 'error'),
    info: (msg: string) => add(msg, 'info'),
    warning: (msg: string) => add(msg, 'warning'),
    remove
  }
}
